import type { DataIdentifier, DocumentKind } from '@onefootprint/request-types/dashboard';
import type { EntityVault } from '@/types/vault';
import getDocumentDataLabelOrdering from '@/utils/get-document-data-label-ordering';

// Get all of the keys in the vault that are (a) associated with the current DocumentType and
// (b) not an image or latest upload (we show these separately).

type GetRelevantDocumentKeysProps = {
  vault: EntityVault;
  documentType: DocumentKind;
  currentDocumentNumber?: string;
};

const getRelevantDocumentKeys = ({ vault, documentType, currentDocumentNumber }: GetRelevantDocumentKeysProps) => {
  // custom documents don't have OCR data
  if (documentType === 'custom') {
    return [];
  }

  const relevantKeys = Object.keys(vault).filter(
    key =>
      key.includes(documentType as string) &&
      // if we aren't looking for a document number, still just return true
      (currentDocumentNumber ? key.includes(currentDocumentNumber) : true) &&
      !key.includes('image') &&
      !key.includes('latest_upload') &&
      !key.includes('classified_document_type') &&
      !key.includes('curp_validation_response'),
  );
  return [...relevantKeys].sort(
    (a, b) => getDocumentDataLabelOrdering(a) - getDocumentDataLabelOrdering(b),
  ) as DataIdentifier[];
};

export default getRelevantDocumentKeys;
